export default {"src":"/_next/static/image/public/images/ic_calendar_blue_vertical_menu.c878b834d8b0b81e7d2e5825d725ae3f.svg","height":20,"width":20};